import axios from 'axios'
import { Modal, message } from 'antd'

const EmptyPresentationSlot = (props) => {
    const handleOk = () => {
        axios.post('/admin/event_slot/clear', {
            campus: props.filterValue.campus,
            slot_type: 1
        })
            .then(function (response) {
                if (response.errcode === 0) {
                    message.success('清空成功！')
                    props.isCancel()
                    props.getSlotData()
                } else {
                    message.error(response.msg)
                }
            })
            .catch(function (error) {
                console.error('请求失败，错误信息为：', error)
            })
    }

    return (
        <Modal
            title="清空宣讲会资源"
            open={props.isOpen}
            onOk={handleOk}
            onCancel={props.isCancel}
            cancelText="取消"
            okType='danger'
            okText='清空'>

            <p>正在将当前校区下的宣讲会资源清空，此操作不可逆，是否确认清空？</p>
        </Modal>
    )
}

export default EmptyPresentationSlot
